import React from 'react';

const Ellipse = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.1" cx="12" cy="12" r="12" fill="#150544" />
    <circle opacity="0.1" cx="12" cy="12" r="8" fill="#150544" />
    <circle cx="12" cy="12" r="4" fill="#150544" />
  </svg>
);

export default Ellipse;
